import React, { Component, createRef, KeyboardEventHandler } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import Creatable from 'react-select/lib/Creatable';
import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
import { ISelectAsyncCreatable, ISelectAsync, ISelectNoneAsync, ISelectNoneAsyncCreatable } from '../../../models/components/input-select';
import { Log } from 'ng2-logger';
import ApiClient from '../../../api/alms-api';
import Translator from '../../../core/i18n';
import { string } from 'prop-types';
import { Notification } from '../../notification/main';
import { InputActionMeta } from 'react-select/lib/types';
import { QuestionService } from '../../../api/question-service';
import { eventNames } from 'process';
import { ApiTypes } from '../../../models/enums/ApiTypes';
import moment from 'moment';
import * as Util from '../../../utils';

const T = Translator.create();
let _apiClient: ApiClient;
const _logger = Log.create('selectComponent.tsx');
const token: any = localStorage.getItem('access_token');
const _questionService = new QuestionService();

const customStyles: any = {
    control: (styles: any) => ({
        ...styles,
        background: 'rgba(0, 0, 0, 0)',
        color: 'white',
        boxShadow: 'none'
    }),
    menu: (styles: any) => ({
        ...styles,
        zIndex: 999999
    }),
    multiValue: (styles: any) => ({
        ...styles,
        backgroundColor: 'White'
    }),
    menuList: (styles: any) => ({
        ...styles,
        padding: 0
    }),
    clearIndicator: (styles: any) => ({
        ...styles,
        color: 'black'
    }),
    dropdownIndicator: (styles: any) => ({
        ...styles,
        color: 'black'
    })
};

interface ISelectAsyncCreatableState {
    selectOptions: Array<{ value: string; label: string }>;
    requestParameter: any;
    selectedOption: Array<{ value: string; label: string }>;
}

// tslint:disable-next-line:max-classes-per-file
export class SelectAsyncCreatable extends React.Component<ISelectAsyncCreatable, ISelectAsyncCreatableState> {
    public state = {
        selectOptions: [{ value: '', label: '' }],
        requestParameter: this.props.parameter,
        selectedOption: [{ value: '', label: '' }]
    };
    public refSelect = createRef<AsyncCreatableSelect<any>>();

    constructor(props: any) {
        super(props);
        _apiClient = new ApiClient();
    }

    public getTranslate = (message: string) => {
        return T.t(message);
    };

    public componentWillReceiveProps = (nextProps: any, prevProps: any) => {
        this.setState(prevState => ({
            requestParameter: {
                ...prevState.requestParameter,
                CourseId: nextProps.parameter.CourseId,
                SearchedText: nextProps.parameter.SearchedText ? nextProps.parameter.SearchedText : '',
                Take: nextProps.parameter.Take,
                Skip: nextProps.parameter.Skip,
                ShowPassiveCourses: nextProps.parameter.ShowPassiveCourses
            },
            selectOptions: []
        }));
    };

    public getOptions = async (changeValue: string = '', callback: any) => {
        if (this.state.requestParameter === undefined || !this.state.requestParameter) {
            this.state.requestParameter = {};
        }
        this.state.requestParameter.SearchedText = changeValue ? changeValue : '';

        const returnApi = await _apiClient
            .RequestAsync(this.props.requestType, this.props.url ? this.props.url : '', this.state.requestParameter, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        this.props.errorMessage ? this.props.errorMessage : T.t('r_select_options_error_message')
                    );
                }
                return responseData.json();
            })
            .then((result: any) => {
                const column: { label: string; value: string } | null = this.props.column;
                if (column !== null) {
                    const selectArray: any = [];
                    result.map((x: any) => {
                        selectArray.push({ label: x[column.label], value: x[column.value] });
                    });
                    if (selectArray.length > 0) {
                        result = selectArray;
                    }
                }

                let options = [];
                if (result != null && result.length > 0) {
                    options = result;
                    this.state.selectOptions = result;
                    if (this.props.setSelectValue) {
                        this.state.selectedOption = this.state.selectedOption = this.state.selectOptions.filter(
                            x => x.value.toString() === this.props.setSelectValue
                        );
                    }
                    this.setState(this.state);
                }
                return options;
            })
            .catch(response => {
                Notification.setNotification(
                    'error',
                    this.props.errorMessage ? this.props.errorMessage : T.t('r_select_options_error_message')
                );
                return [];
            });
        return returnApi;
    };

    public onChange = (event: any) => {
        this.state.selectedOption = event;

        if (this.props.isMulti && this.props.maxChoice) {
            if (event && event.length > this.props.maxChoice) {
                return false;
            }
        }
        if (event && this.props.onChange) {
            this.props.onChange(event);
        }
        this.setState(this.state);
    };

    public render() {
        return (
            <div style={{ width: '100%' }}>
                <AsyncCreatableSelect
                    value={this.state.selectedOption}
                    onChange={this.onChange}
                    className={'selectDropwon'}
                    loadOptions={this.getOptions}
                    defaultOptions={true}
                    isMulti={this.props.isMulti ? this.props.isMulti : false}
                    autoFocus={true}
                    ref={this.refSelect}
                    readOnly
                    isClearable={true}
                    // tslint:disable-next-line:jsx-no-lambda
                    noOptionsMessage={() => this.getTranslate('r_select_noRecord')}
                    // tslint:disable-next-line:jsx-no-lambda
                    loadingMessage={() => this.getTranslate('r_select_loading')}
                    // tslint:disable-next-line:jsx-no-lambda
                    formatCreateLabel={value => <span>{this.getTranslate('r_select_create')}</span>}
                    placeholder={this.props.placeHolder}
                    styles={this.props.colourStyles ? this.props.colourStyles : customStyles}
                    isSearchable={this.props.isSearchable ? this.props.isSearchable : false}
                />
            </div>
        );
    }
}

// tslint:disable-next-line:max-classes-per-file
export class SelectNoneAsyncCreatable extends React.Component<ISelectNoneAsyncCreatable> {
    public state = {
        selectedOption: [],
        selectOptions: this.props.setOptions
    };
    constructor(props: any) {
        super(props);
    }

    public getTranslate = (message: string) => {
        return T.t(message);
    };

    public onChange = (event: any) => {
        if (this.props.isMulti && this.props.maxChoice) {
            if (event && event.length > this.props.maxChoice) {
                return false;
            }
        }
        if (event && this.props.onChange) {
            this.props.onChange(event);
        }
        this.setState({ selectedOption: event });
    };

    public render() {
        return (
            <div style={{ width: '100%' }}>
                <Creatable
                    value={this.state.selectedOption}
                    onChange={this.onChange}
                    className={'selectDropwon'}
                    defaultOptions={this.state.selectOptions}
                    isMulti={this.props.isMulti ? this.props.isMulti : false}
                    autoFocus={false}
                    readOnly
                    isClearable={true}
                    // tslint:disable-next-line:jsx-no-lambda
                    noOptionsMessage={() => this.getTranslate('r_select_noRecord')}
                    // tslint:disable-next-line:jsx-no-lambda
                    formatCreateLabel={value => <span>{this.getTranslate('r_select_create')}</span>}
                    placeholder={this.props.placeHolder}
                    styles={this.props.colourStyles ? this.props.colourStyles : customStyles}
                />
            </div>
        );
    }
}

interface ISelectAsyncState {
    selectOptions: Array<{ value: string; label: string }>;
    requestParameter: any;
    selectedOption: Array<{ value: string; label: string }>;
    selectAllOptions: boolean;
    onComplate: boolean;
    validateBarGuid: string;
    isOtherColorActive: boolean;
    selectBorderColor: string;
    isUpdate: boolean;
    defaultOptions?: boolean;
    isLoading: boolean;

    initialProcessPassed: boolean;
    initialWeekDate: boolean;
    noResultsStatu: boolean;
}

// tslint:disable-next-line:max-classes-per-file
export class SelectAsync extends React.Component<ISelectAsync, ISelectAsyncState> {
    public validateDiv: HTMLDivElement | null = null;

    public state = {
        selectOptions: [{ value: '', label: '' }],
        requestParameter: this.props.parameter,
        selectedOption: [{ value: '', label: '' }],
        selectAllOptions: false,

        onComplate: false,
        validateBarGuid: '',
        isOtherColorActive: false,
        selectBorderColor: '',
        isUpdate: false,
        defaultOptions: true,
        isLoading: true,

        initialProcessPassed: false,
        initialWeekDate: true,
        noResultsStatu: true
    };
    public refSelect = createRef<AsyncSelect<any>>();

    constructor(props: any) {
        super(props);
        _apiClient = new ApiClient();
        this.state.selectedOption = [];
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    public async onKeyDown(event: any) {
        if (event && event.keyCode === 13 && event.target.value && event.target.value.length > 0 && this.props.insertUrl) {
            await _apiClient
                .RequestAsync('POST', 'api/question/' + this.props.insertUrl + '', { value: event.target.value }, token)
                .then((responseData: Response) => {
                    if (responseData.status === 200) {
                        Notification.setNotification('success', T.t(this.props.infoMessage));
                    } else {
                        Notification.setNotification(
                            'error',
                            this.props.errorMessage ? this.props.errorMessage : T.t('r_select_options_error_message')
                        );
                    }
                    return responseData.json();
                })
                .then((result: any) => {
                    const column: { label: string; value: string } | undefined = result;
                    if (column !== undefined) {
                        const selectArray: any = [];
                        result.map((x: any) => {
                            selectArray.push({ label: x.label, value: x.value });
                        });
                        if (selectArray.length > 0) {
                            result = selectArray;
                            const selected = this.state.selectedOption;
                            result.forEach((element: any) => {
                                selected.push(element);
                            });

                            this.setState({ selectedOption: selected });
                            const selectedOptions: any = [];
                            this.state.selectedOption.forEach(element => {
                                selectedOptions.push(element.value);
                            });

                            const request = this.state.requestParameter;
                            request.SelectedIds = selectedOptions;
                            this.setState({ requestParameter: request });
                            this.props.setFieldValue(this.props.name, selectedOptions);
                        }
                    }
                })
                .catch(responseData => {
                    return responseData;
                });
            this.getOptions('');
            this.refSelect.current && this.refSelect.current.blur();
        } else if (event.keyCode === 8) {
            this.getOptions('');
        }

        this.setState({ noResultsStatu: true });
    }

    public addTag = async (param = null) => {
        await _apiClient
            .RequestAsync('POST', 'api/question/' + this.props.insertUrl + '', { value: param }, token)
            .then((responseData: Response) => {
                if (responseData.status === 200) {
                    Notification.setNotification('success', T.t(this.props.infoMessage));
                } else {
                    Notification.setNotification(
                        'error',
                        this.props.errorMessage ? this.props.errorMessage : T.t('r_select_options_error_message')
                    );
                }

                return responseData.json();
            })
            .then((result: any) => {
                const column: { label: string; value: string } | undefined = result;
                if (column !== undefined) {
                    const selectArray: any = [];
                    result.map((x: any) => {
                        selectArray.push({ label: x.label, value: x.value });
                    });
                    if (selectArray.length > 0) {
                        result = selectArray;
                        const selected = this.state.selectedOption;
                        result.forEach((element: any) => {
                            selected.push(element);
                        });

                        this.setState(prevState => ({ selectedOption: selected }));
                        const selectedOptions: any = [];
                        this.state.selectedOption.forEach(element => {
                            selectedOptions.push(element.value);
                        });

                        const request = this.state.requestParameter;
                        request.SelectedIds = selectedOptions;
                        this.setState(prevState => ({ requestParameter: request }));
                        this.props.setFieldValue(this.props.name, selectedOptions);
                    }
                }
            })
            .catch(responseData => {
                return responseData;
            });
        this.setState({ noResultsStatu: false });
    };

    public getTranslate = (message: string, param = null) => {
        if (param != null) {
            if (this.props.canAddable) {
                return (
                    <a onMouseDown={event => this.addTag(param)}>
                        {param} {'(' + T.t(message) + ')'}
                    </a>
                );
            } else {
                return T.t(message);
            }
        } else {
            return T.t(message);
        }
    };

    public async componentDidMount() {
        this.setState({
            ...this.state,
            defaultOptions: this.props.defaultOptions
        });
        await this.getOptions('', '').then(() => {
            if (this.props.isAll) {
                this.setState({ selectedOption: this.state.selectOptions });
                if (this.props.setFieldValue) {
                    this.props.isTouched(this.props.name, true);
                    this.props.setFieldValue(this.props.name, this.state.selectOptions);
                }
            }
            if (this.props.name === 'examCategoryId' && this.state.selectedOption && this.state.selectedOption.length > 0) {
                if (this.props.setFieldValue) {
                    this.props.isTouched(this.props.name, true);
                    this.props.setFieldValue(this.props.name, this.state.selectedOption[0].value);
                }
            } else if (this.props.name === 'virtualClassType' && this.state.selectOptions && this.state.selectOptions.length > 0) {
                if (this.props.setFieldValue) {
                    this.props.isTouched(this.props.name, true);
                    this.props.setFieldValue(this.props.name, this.state.selectOptions[0].value);
                }
            }
        });
    }

    updateSelectedIds = (nextProps: any) => {
        const currentSelectedIds = this.props.parameter.SelectedIds;
        const nextSelectedIds = nextProps.parameter.SelectedIds;

        if ((currentSelectedIds?.length === 0 && nextSelectedIds?.length > 0) || this.props.onChangeRequest) {
            this.setState(prevState => ({
                requestParameter: {
                    ...prevState.requestParameter,
                    SelectedIds: nextSelectedIds
                }
            }));
            this.getOptions('');
        }
    };

    isSelectedAll = (nextProps: any) => {
        if (this.props.isAll !== nextProps.isAll) {
            if (nextProps.isAll) {
                this.getOptions('', '').then(() => {
                    this.setState({ selectedOption: this.state.selectOptions });
                    if (this.props.setFieldValue) {
                        this.props.isTouched(this.props.name, true);
                        this.props.setFieldValue(this.props.name, this.state.selectOptions);
                    }
                });
            } else {
                this.setState({ selectedOption: [] });
                if (this.props.setFieldValue) {
                    this.props.isTouched(this.props.name, true);
                    this.props.setFieldValue(this.props.name, []);
                }
            }
        }
    };

    updateRequestParameterState = (nextProps: any) => {
        if (this.state.requestParameter) {
            this.setState(prevState => ({
                requestParameter: {
                    ...prevState.requestParameter,
                    CourseId: nextProps.parameter.CourseId,
                    SearchedText: nextProps.parameter.SearchedText ? nextProps.parameter.SearchedText : '',
                    Take: nextProps.parameter.Take,
                    Skip: nextProps.parameter.Skip,
                    ShowPassiveCourses: nextProps.parameter.ShowPassiveCourses
                }
            }));
        }
    };

    updateRequestParameters = (nextProps: any) => {
        if ((this.props.parameter.SelectedIds && nextProps.parameter.SelectedIds) || this.props.onChangeRequest) {
            this.updateSelectedIds(nextProps);
        }
        if (
            this.props.parameter.CourseIds &&
            nextProps.parameter.CourseIds &&
            this.props.parameter.CourseIds !== nextProps.parameter.CourseIds
        ) {
            this.setState(prevState => ({
                requestParameter: {
                    ...prevState.requestParameter,
                    CourseIds: nextProps.parameter.CourseIds
                }
            }));
            this.getOptions('');
        }
        if (
            this.props.parameter.ClassIds &&
            nextProps.parameter.ClassIds &&
            this.props.parameter.ClassIds !== nextProps.parameter.ClassIds
        ) {
            this.setState(prevState => ({
                requestParameter: {
                    ...prevState.requestParameter,
                    ClassIds: nextProps.parameter.ClassIds
                }
            }));
            this.getOptions('');
        }
        if (
            this.props.parameter.ActivityTypes &&
            nextProps.parameter.ActivityTypes &&
            this.props.parameter.ActivityTypes !== nextProps.parameter.ActivityTypes
        ) {
            this.setState(prevState => ({
                requestParameter: {
                    ...prevState.requestParameter,
                    ActivityTypes: nextProps.parameter.ActivityTypes
                }
            }));
            this.getOptions('');
        }
        if (
            this.props.parameter.ShowPassiveCourses &&
            nextProps.parameter.ShowPassiveCourses &&
            this.props.parameter.ShowPassiveCourses !== nextProps.parameter.ShowPassiveCourses
        ) {
            this.setState(prevState => ({
                requestParameter: {
                    ...prevState.requestParameter,
                    ShowPassiveCourses: nextProps.parameter.ShowPassiveCourses
                }
            }));
            this.getOptions('');
        }
    };

    public componentWillReceiveProps = (nextProps: any, prevProps: any) => {
        if (this.props.parameter) {
            this.updateRequestParameters(nextProps);
        } else if (this.props.onChangeRequest) {
            this.updateSelectedIds(nextProps);
        }

        this.updateRequestParameterState(nextProps);

        this.isSelectedAll(nextProps);
    };

    public getOptions = async (changeValue: string = '', callback?: any) => {
        this.setState({ isLoading: true });

        if (
            this.state.requestParameter &&
            !this.state.requestParameter.SelectedIds &&
            this.state.requestParameter.isTiming &&
            this.props.setSelectValue
        ) {
            this.state.requestParameter.SelectedIds = this.props.setSelectValue;
        }

        if (this.props.isSearchable) {
            this.state.requestParameter.SearchedText = changeValue;
            if (this.props.isAll) {
                this.state.requestParameter.SearchedText = changeValue = '';
            }

            if(this.props.name === 'prerequisiteActivityId'){
                let array: any = [];
                array.push(this.props.setSelectValue);
                this.state.requestParameter.SelectedIds = array;
            }
        }

        if (
            this.props.initialProcess === null ||
            this.props.initialProcess === undefined ||
            this.props.initialProcess === true ||
            (this.props.initialProcess === false && this.state.initialProcessPassed === true)
        ) {
            const returnApi = await _apiClient
                .RequestAsync(
                    this.props.requestType,
                    this.props.url ? this.props.url : '',
                    this.state.requestParameter,
                    token,
                    false,
                    ApiTypes.None
                )
                .then((responseData: Response) => {
                    if (this.props.callback) {
                        this.props.callback();
                    }
                    if (responseData.status !== 200) {
                        Notification.setNotification(
                            'error',
                            this.props.errorMessage ? this.props.errorMessage : T.t('r_select_options_error_message')
                        );
                    }
                    return responseData.json();
                })
                .then((result: any) => {
                    const column: { label: string; value: string } | undefined = this.props.column;
                    if (column !== undefined) {
                        const selectArray: any = [];
                        result.map((x: any) => {
                            selectArray.push({ label: T.t(x[column.label]), value: x[column.value] });
                        });
                        if (selectArray.length > 0) {
                            result = selectArray;
                        }
                    }

                    let options = [];
                    let counter = 0;
                    if (result != null && result.length > 0) {
                        if (this.props.hasLocalization) {
                            result = this.localization(result);
                        }
                        const checkResult = result;
                        checkResult.forEach((element: any) => {
                            if (this.props.requestType == 'post' && element.label.includes('r_exam_difficulty_')) {
                                element.label = T.t(element.label);
                            } else if (element.label && element.label.includes('r_helpdesk_status_')) {
                                const temp = T.t(element.label);
                                element.label = temp;
                            } else if (element.label === null) {
                                counter += 1;
                                checkResult.splice(element.label, counter);
                            }
                        });

                        if (this.props.url === 'api/lti/names') {
                            const filteredResult = checkResult.filter((element: any) => element.label && element.label.trim() !== '');
                            checkResult.length = 0;
                            checkResult.push(...filteredResult);
                        }

                        if (
                            this.props.url === 'api/term/courseweeks' &&
                            this.props.value &&
                            this.props.value.length === 0 &&
                            this.props.parameter.activityConditionalBeginDate === null
                        ) {
                            this.state.initialWeekDate = false;
                        }

                        if (
                            this.props.url === 'api/term/courseweeks' &&
                            this.state.initialWeekDate &&
                            this.props.value &&
                            this.props.value.length === 0
                        ) {
                            checkResult.forEach((element: any) => {
                                let rangeDate = element.label.split('- ')[1];

                                let startDate = rangeDate.split('/')[0];
                                let startDateDay = startDate.split('.')[0];
                                let startDateMount = startDate.split('.')[1];
                                let startDateYear = startDate.substring(startDate.length - 4, startDate.length);
                                let startDateFormatted = startDateMount + '/' + startDateDay + '/' + startDateYear;

                                let endDate = rangeDate.split('/')[1];
                                let endDateDay = endDate.split('.')[0];
                                let endDateMount = endDate.split('.')[1];
                                let endDateYear = endDate.substring(endDate.length - 4, endDate.length);
                                let endDateFormatted = endDateMount + '/' + endDateDay + '/' + endDateYear;

                                let nowDateFormatted = moment(new Date()).format('MM/DD/YYYY');

                                let isBetween = Util.dateCheck(startDateFormatted, endDateFormatted, nowDateFormatted);
                                if (isBetween) {
                                    this.state.initialWeekDate = false;
                                    this.onChange([element]);
                                }
                            });
                        }

                        options = checkResult;
                        this.state.selectOptions = checkResult;
                        this.state.isUpdate = true;
                        this.setState(this.state);
                    } else {
                        this.state.selectOptions = [];
                        this.setState(this.state);
                    }

                    this.setState({ isLoading: false });
                    if (this.props.setStateClasses) {
                        this.props.setStateClasses(options);
                    }
                    return options;
                })
                .catch(response => {
                    Notification.setNotification(
                        'error',
                        this.props.errorMessage ? this.props.errorMessage : T.t('r_select_options_error_message')
                    );

                    this.state.selectOptions = [];
                    this.setState(this.state);
                    return [];
                });

            return returnApi;
        }

        this.setState({ initialProcessPassed: true });
    };

    public localization = (result: any) => {
        result.map((item: any) => {
            if (item.label) {
                const rText = item.label.match(/# *([^#]+)#/);
                if (rText) {
                    item.label = item.label.replace(rText[0], T.t(rText[1]));
                }
            }
        });

        return result;
    };

    public onChange = async (event: any) => {
        this.state.selectedOption = event;

        if (this.props.isMulti && this.props.maxChoice) {
            if (event && event.length > this.props.maxChoice) {
                return false;
            }
        }
        if (event && this.props.onChange) {
            this.props.onChange(event);
        }
        if (!event && this.props.isClearable) {
            this.props.onChange({ label: '', value: '' });
        }

        this.setState(this.state);

        let obj = null;
        if (this.props.isMulti === false) {
            obj = [];
            obj.push(this.state.selectedOption);
        } else {
            obj = this.state.selectedOption;
        }
        if (this.props.setFieldValue) {
            this.props.isTouched(this.props.name, true);
            if (this.props.setFieldOnlyValue) {
                if (this.props.isMulti) {
                    const values: string[] = [];
                    if (this.state.selectedOption && this.state.selectedOption.length) {
                        this.state.selectedOption.forEach(o => {
                            values.push(o.value.toString());
                        });

                        const _requestParam = this.state.requestParameter;
                        _requestParam.SelectedIds = values;
                        this.setState({ requestParameter: _requestParam });
                    }
                    const _requestParameter = this.state.requestParameter;
                    _requestParameter.SelectedIds = values;
                    this.setState({ requestParameter: _requestParameter });
                    this.props.setFieldValue(this.props.name, values);
                } else {
                    if (obj) {
                        obj.forEach((element: any) => {
                            if (element) {
                                this.props.setFieldValue(this.props.name, element.value);
                            } else {
                                this.props.setFieldValue(this.props.name, '');
                            }
                        });
                    }
                }
            } else {
                this.props.setFieldValue(this.props.name, obj);
            }
        }
    };

    public onValid() {
        if (!this.props.isDisabled && this.props.touched && this.props.errors && this.validateDiv) {
            this.validateDiv.innerText = this.props.errors;
            this.state.selectBorderColor = 'solid 2px #FF6F61';
            this.validateDiv.classList.remove('success');
            this.validateDiv.classList.add('error');
            const getValidateElement = document.getElementById(this.state.validateBarGuid);
            if (getValidateElement) {
                getValidateElement.style.backgroundColor = '#FF6F61';
                getValidateElement.style.width = '100%';
                this.state.isOtherColorActive = true;
            }
        } else if (!this.props.isDisabled && this.props.touched && !this.props.errors && this.validateDiv) {
            if (this.state.selectedOption && this.state.selectedOption.length) {
                this.validateDiv.innerText = '';
                this.state.selectBorderColor = 'solid 2px #39B27B';
            } else {
                this.state.selectBorderColor = '';
                this.validateDiv.innerText = '';
            }
            this.validateDiv.classList.remove('error');
            this.validateDiv.classList.add('success');
            const getValidateElement = document.getElementById(this.state.validateBarGuid);
            if (getValidateElement) {
                getValidateElement.style.backgroundColor = '#39B27B';
                getValidateElement.style.width = '100%';
                this.state.isOtherColorActive = true;
            }
        } else {
            this.state.selectBorderColor = '';
            if (this.validateDiv) {
                this.validateDiv.innerText = '';
            }
        }
    }

    public setUpdatedValue() {
        if (this.props.setSelectValue && this.props.setSelectValue.length > 0) {
            const selected: any = [];
            let array: any = [];
            if (typeof this.props.setSelectValue === 'string') {
                array.push(this.props.setSelectValue);
            } else {
                array = this.props.setSelectValue;
            }
            let index = 0;
            for (index; index < array.length; index++) {
                let _selected = this.state.selectOptions.find(x => (x.value ? x.value.toString() : null) === array[index]);
                if (_selected) {
                    selected.push(_selected);
                } else {
                    _selected = this.state.selectOptions.find(x => (x.label ? x.label.toString() : null) === array[index]);
                    selected.push(_selected);
                }
            }
            this.state.selectedOption = selected;
            this.state.isUpdate = false;
            if (this.props.triggerOnChangeOnUpdate) {
                if (this.props.url === 'api/exam/topic/get') {
                    this.props.onChange(this.state.selectedOption);
                } else {
                    this.props.onChange(this.state.selectOptions);
                }
            }
        }
    }

    handleInputChange = async (newValue: string, actionMeta: InputActionMeta) => {
        if (!newValue && (actionMeta.action === 'input-change' || actionMeta.action === 'menu-close')) {
            await this.getOptions('');
        }
    };

    onFocus = async () => {
        if (this.props.isTouched || (!this.props.initialProcess && this.props.touched && this.props.name === 'examAddStudentsUserIds')) {
            await this.getOptions('');
        }
    };

    setAsyncSelectValue = (defaultValue: any) => {
        let asyncSelectValue = null;

        if (!this.props.isDisabled) {
            if (this.state.selectedOption && this.props.url === 'api/virtualclass/getvirtualclasstypes') {
                if (!Array.isArray(this.state.selectedOption)) {
                    asyncSelectValue = this.state.selectedOption;
                } else {
                    asyncSelectValue = defaultValue;
                }
            } else {
                asyncSelectValue = this.state.selectedOption;
            }
        }
        return asyncSelectValue;
    };

    returnNoOptionText = () => {
        let noOptionText = 'r_select_no_another_Record';
        if (this.props.canAddable) {
            noOptionText = 'r_new_add';
        }
        return noOptionText;
    };

    public render() {
        this.onValid();
        if (this.state.isUpdate) {
            this.setUpdatedValue();
        }
        let defaultValue: any = null;
        if (this.state.selectOptions && this.state.selectOptions.length > 0 && this.props.name === 'virtualClassType') {
            defaultValue = this.state.selectOptions[0];
        }

        let asyncSelectValue = this.setAsyncSelectValue(defaultValue);
        let noOptionText = this.returnNoOptionText();
        return (
            <>
                <div style={{ width: '100%', borderBottom: this.state.selectBorderColor }}>
                    <AsyncSelect
                        name={this.props.name}
                        value={asyncSelectValue}
                        onChange={this.onChange}
                        className={'selectDropwon' + this.props.className && " " +this.props.className}
                        readOnly
                        loadOptions={this.getOptions}
                        defaultOptions={this.state.selectOptions}
                        isMulti={this.props.isMulti ? this.props.isMulti : false}
                        autoFocus={false}
                        closeMenuOnScroll={!this.props.closeMenuOnScroll ? this.props.closeMenuOnScroll : true}
                        closeMenuOnSelect={!this.props.closeMenuOnSelect ? this.props.closeMenuOnSelect : true}
                        isSearchable={this.props.isSearchable ? this.props.isSearchable : false}
                        cacheOptions={false}
                        ref={this.refSelect}
                        // tslint:disable-next-line:jsx-no-lambda
                        noOptionsMessage={() =>
                            this.state.noResultsStatu === true && this.state.requestParameter
                                ? this.getTranslate(noOptionText, this.state.requestParameter.SearchedText)
                                : this.getTranslate('r_select_noRecord')
                        }
                        // tslint:disable-next-line:jsx-no-lambda
                        loadingMessage={() => this.getTranslate('r_default_loading_message')}
                        placeholder={this.props.placeHolder}
                        styles={this.props.colourStyles ? this.props.colourStyles : customStyles}
                        isDisabled={this.props.isDisabled ? this.props.isDisabled : false}
                        isClearable={this.props.isClearable}
                        isLoading={this.state.isLoading}
                        onKeyDown={this.onKeyDown}
                        onFocus={this.onFocus}
                        noResultsText={this.state.noResultsStatu}
                    />
                </div>
                {this.props.isManualLoading && this.state.isLoading ? (
                    <div style={{ position: 'absolute', top: 6, width: '100%', height: '100%' }}>
                        <span style={{ position: 'absolute', right: 57, cursor: 'default', top: 10 }}>
                            <div className="dot-flashing" />
                        </span>
                    </div>
                ) : (
                    ''
                )}
                <div ref={e => (this.validateDiv = e)} className="" />
            </>
        );
    }
}

// tslint:disable-next-line:max-classes-per-file
export class SelectNoneAsync extends React.Component<ISelectNoneAsync> {
    public validateDiv: HTMLDivElement | null = null;

    public state = {
        selectedOption: [],
        selectOptions: this.props.setOptions,
        isOtherColorActive: false,
        selectBorderColor: '',
        isUpdated: true
    };
    constructor(props: any) {
        super(props);
        this.props.setSelectValue ? this.getOptions() : ''.toString();
    }

    componentDidUpdate(prevProps: ISelectNoneAsync) {
        if (prevProps.setOptions !== this.props.setOptions) {
            this.setState({ selectOptions: this.props.setOptions });
        }
    }
    
    public getOptions() {
        const values: any = [];
        this.state.isUpdated = false;
        if (this.props.isMulti) {
            let index = 0;
            for (index; index < this.props.setSelectValue.length; index++) {
                values.push(this.state.selectOptions.find(x => x.value === this.props.setSelectValue[index]));
            }
            this.state.selectedOption = values;
            this.props.onChange(values);
        } else {
            values.push(this.state.selectOptions.find(x => x.value === this.props.setSelectValue[0]));
            this.state.selectedOption = values[0];
            this.props.onChange(values[0]);
        }

        if (this.state.selectOptions && this.state.selectOptions.length > 0 && this.props.name === 'virtualClassType') {
            this.onChange(this.state.selectOptions[0]);
        }
    }

    public getTranslate = (message: string) => {
        return T.t(message);
    };

    public onChange = (event: any) => {
        if (this.props.isMulti && this.props.maxChoice) {
            if (event && event.length > this.props.maxChoice) {
                return false;
            }
        }
        if (this.props.onChange) {
            this.props.onChange(event, this.props.name);
        }
        this.setState({ selectedOption: event });
        if (this.props.isTouched) {
            this.props.isTouched(this.props.name, true);
        }
    };

    public onValid() {
        if (this.props.touched && this.props.errors && this.validateDiv) {
            this.validateDiv.innerText = this.props.errors;
            this.state.selectBorderColor = 'solid 1px #FF6F61';
            this.validateDiv.classList.remove('success');
            this.validateDiv.classList.add('error');
        } else if (this.props.touched && !this.props.errors && this.validateDiv) {
            if (this.state.selectedOption) {
                this.state.selectBorderColor = 'solid 1px #39B27B';
                this.validateDiv.innerText = '';
            } else {
                this.state.selectBorderColor = '';
                this.validateDiv.innerText = '';
            }
            this.validateDiv.classList.remove('error');
            this.validateDiv.classList.add('success');
        } else {
            this.state.selectBorderColor = '';
            if (this.validateDiv) {
                this.validateDiv.innerText = '';
            }
        }
    }

    public render() {
        this.onValid();
        this.props.setSelectValue && this.state.isUpdated ? this.getOptions() : ''.toString();
        let defaultValue: any = null;
        if (this.state.selectOptions && this.state.selectOptions.length > 0 && this.props.name === 'virtualClassType') {
            defaultValue = this.state.selectOptions[0];
        }

        return (
            <>
                <div style={{ width: '100%', borderBottom: this.state.selectBorderColor }}>
                    <Select
                        name={this.props.name ? this.props.name : 'select'}
                        value={this.state.selectedOption ? this.state.selectedOption : defaultValue}
                        onChange={this.onChange}
                        // className={'selectDropwon'}
                        className={this.props.className ? this.props.className : 'selectDropwon'}
                        readOnly
                        options={this.state.selectOptions}
                        isMulti={this.props.isMulti ? this.props.isMulti : false}
                        autoFocus={false}
                        isClearable={this.props.isClearable}
                        // tslint:disable-next-line:jsx-no-lambda
                        noOptionsMessage={() => this.getTranslate('r_select_noRecord')}
                        placeholder={this.props.placeHolder ? this.props.placeHolder : ''}
                        styles={this.props.colourStyles ? this.props.colourStyles : customStyles}
                        isDisabled={this.props.disable ? this.props.disable : false}
                    />
                </div>
                <div ref={e => (this.validateDiv = e)} className="" />
            </>
        );
    }
}
